<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="chap-number-new"><span class="Character-Style-1 CharOverride-8">To my father, Anthony Aliberti, and all the words he loved.</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Text-Frame" id="_idContainer010">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame _idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
<div class="_idGenObjectStyleOverride-2" id="_idContainer023">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// what_wind_can_tell_you_interior_12_pt4.vue?1826ce2e